import { render, staticRenderFns } from "./KaiDangerCtaButton.vue?vue&type=template&id=a5360c78&scoped=true&"
var script = {}
import style0 from "./KaiDangerCtaButton.vue?vue&type=style&index=0&id=a5360c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5360c78",
  null
  
)

export default component.exports